module.exports = __webpack_public_path__ + "static/img/1971.d0891b45.jpg";